/**
 * All authentication function
 */

import axios from 'axios';
import y, { isNotEmptyString, md5 } from 'y4/Utils';

const t_key = 'a15ad93e144548d3a4d647af17d46cb5_t';

/** Set authentication after login,
 * and load data from back end at initializtion
 * @param {*} corp
 * @param {*} data
 * @param {*} remember
 */
function setAuthentication(corp, data, remember) {
  const a_key = md5(corp) + '_a';

  /* Sample of data
    const data =  {
        "department": "1U000012004",
        "user": "18203000012",
        "userFullName": "兰博立德商城>管理员",
        "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJk"
    };

    department: "1U000014002"
    team: "U000014"
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkZXBhcnRtZW50IjoiMVUwMDAwMTQwMDIiLCJ1c2VyIjoib0d2Vnp1TEp3aWdWVmhVdXo2NkhmdjI1eTZ5USIsImd1aWQiOiI2YjkxOTY0Ny1kMzkzLTQ2MjktODU4OS0zOGEzZjEwODYxM2UiLCJzeXN0ZW0iOiIyMCIsInRlYW0iOiJVMDAwMDE0IiwibmJmIjoxNzI0NjQyODIyLCJleHAiOjE3MjY0NDI4MjIsImlzcyI6Ink0IiwiYXVkIjoieTRjb25zdW1lciJ9.i2p-PLstOUoz-jqewVB-1xRd6hBlZWjT66oMV3qvYRQ"
    user: "oGvVzuLJwigVVhUuz66Hfv25y6yQ"
    userFullName: "一亩三分地儿"
    userHeadImage: "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83epAzZXJyjUtQv6glF0nHqtDSibwryF20Bdh9ia18388FTcgMBwuOKmt66GS4GXuy7jZiaicJKcQW6uS9g/132"
  */

  //First clear current authentication.
  clearAuthentication();

  axios.defaults.headers.common['token'] = data.token;
  if (remember) {
    y.setLocalItem(a_key, JSON.stringify(data));
    y.setLocalItem(t_key, data.token);
  } else {
    y.setSessionItem(a_key, JSON.stringify(data));
    y.setSessionItem(t_key, data.token);
  }
}

/** Get current authentication info
 * @returns
 */
function getAuthentication(corp) {
  const a_key = md5(corp) + '_a';
  let auth = y.getSessionItem(a_key);
  //Then parse to json
  if (auth) {
    return JSON.parse(auth);
  }
  return null;
}

/** For ProtectedElement
 * using to determine whether user is authorized
 *  * @returns boolean
 */
function isAuthorized(corp) {
  const a_key = md5(corp) + '_a';
  //First load from session
  let auth = y.getSessionItem(a_key);
  //If null then load from auth
  if (!auth) {
    auth = y.getLocalItem(a_key);
    const token = y.getLocalItem(t_key);
    if (auth && token) {
      //Then copy from local to session.Other code read info from sessionStorage
      y.setSessionItem(a_key, auth);
      y.setSessionItem(t_key, token);
    }
  }
  return isNotEmptyString(auth);
}

/**
 * Clear current login info
 */
function clearAuthentication() {
  localStorage.clear();
  sessionStorage.clear();
  delete axios.defaults.headers.common['token'];
}

export {
  setAuthentication,
  getAuthentication,
  clearAuthentication,
  isAuthorized
};
